module.exports = __webpack_public_path__ + "img/person_-_homepage.880ae9fe.png";